// extracted by extract-css-chunks-webpack-plugin
module.exports = {"course":"course_R6ZSV","title":"title_nYvHe","content":"content_dR+Wg","list":"list_ECKC0"};